<template>
  <div>
    <multiselect-ajax
        :key="`${_uid}-folder-or-sales-plan`"
        :name="name || 'folder_or_sales_plan'"
        :placeholder="placeholder || $t('Select {something}', { something: $t('sale_notes.folder_or_sales_plan_id') })"
        :value="value"
        @input="(v) => onInput(v)"
        @update:selected="$emit('update:selected', $event)"
        :custom-label="customLabel"
        :required="required"
        :disabled="disabled"
        :url="`/v1/sale_orders/folder-or-sales-plan-options`"
        :params="{ ...params }"
        :open-direction="openDirection"
        :multiple="multiple"
    >
      <template v-slot:option="{ option }">
        <slot name="option" v-bind="{ option }">{{ customLabel(option) }}</slot>
      </template>
    </multiselect-ajax>
  </div>
</template>

<script>
import MultiselectAjax from "../vue-multiselect-ajax";

export default {
  name: "folder-or-sales-plan-multiselect-ajax",
  components: {
    MultiselectAjax,
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    value: {
      type: Array,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default(option) {
        if (!option || option.id === undefined) {
          return "";
        }
        return option.ref_id;
      }
    },
    openDirection: {
      type: String,
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event);
    },
    clearAll() {
      this.$emit('input', undefined);
    }
  }
}
</script>

<style scoped>
</style>
